// extracted by mini-css-extract-plugin
export default {"bot":"styles_bot__9ljo1","cont":"styles_cont__HYnFV"};